const COMPLETE_URL_PATTERN = /^[a-z][a-z\d+.-]*:/i
const PROTOCOL_RELATIVE_PATTERN = /^\/\//
const UPLOADED_FILE_PATTERN = /^\/?img\//i

/** 判断图片地址是否已经包含可独立使用的协议。 */
export function isCompleteImageUrl(value) {
  return COMPLETE_URL_PATTERN.test(String(value || '').trim())
}

/**
 * 将后端返回的相对图片路径转换为浏览器可直接访问的完整地址。
 * 默认使用管理后台当前域名作为图片域名，同时支持显式传入独立的图片服务地址。
 */
export function resolveImageUrl(value, baseUrl) {
  const source = String(value || '').trim()
  if (!source || isCompleteImageUrl(source)) return source

  if (PROTOCOL_RELATIVE_PATTERN.test(source)) {
    const protocol = typeof window !== 'undefined' && window.location.protocol
      ? window.location.protocol
      : 'https:'
    return `${protocol}${source}`
  }

  const runtimeOrigin = typeof window !== 'undefined' && window.location.origin
    ? window.location.origin
    : ''
  const base = String(baseUrl || runtimeOrigin).trim().replace(/\/+$/, '')
  const normalizedPath = source
    .replace(/\\/g, '/')
    .replace(/^\.\//, '')
    .replace(/^\/+/, '')

  if (UPLOADED_FILE_PATTERN.test(source)) {
    const downloadPath = `/callComponent/download/getFile/file?communityId=-1&fileId=${encodeURIComponent(normalizedPath)}`
    return base ? `${base}${downloadPath}` : downloadPath
  }

  return base ? `${base}/${normalizedPath}` : `/${normalizedPath}`
}
